<template>

    <label for="item-select">Select a show date:</label>
    <select id="item-select" v-model="selectedDate">
        <option value="null" disabled selected>-- Please select an option --</option>
        <option v-for="perfDate in distinctUsedDates" :key="perfDate" :value="perfDate">
            {{ perfDate }}
        </option>
    </select>

    <div>
        <div class="sectionTitle">Used Photos ({{ usedPhotos.length }})</div>
        <div class="photoGridUsed">
            <span class="imgContainer" v-for="photo in filteredUsedPhotos" :key="photo.id">
                <img :src="photo.url" class="gridImg">
                <div class="thumbDesc">@MrSqueak</div>
            </span>
        </div>
    </div>

</template>


<script>
// import constants from '../../../photo-prov-shared/lib/classes/constants.mjs';

export default {
    name: 'UsedPhotosGrid',

    props: {
        usedPhotos: Array,
        initialValue: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            selectedDate: this.initialValue,
        };
    },

    computed: {
        distinctUsedDates() {
            if (this.usedPhotos) {
                const uniqueDates = new Set();
                this.usedPhotos.forEach(photo => {
                    if (photo.usedInPerfDate) {
                        uniqueDates.add(photo.usedInPerfDate);
                    }
                });
                return Array.from(uniqueDates);
            }
            return [];
        },

        filteredUsedPhotos() {
            if (this.selectedDate) {
                return this.usedPhotos.filter(photo => photo.usedInPerfDate === this.selectedDate);
            }
            // else... return all photos
            return this.usedPhotos;
        }

    },

    methods: {

    },
};
</script>

<style scoped>
.photoGridUsed {
    border: 0px dotted orange;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 10px;
    background-color: lightskyblue;
}

.sectionTitle {
    text-align: center;
    font-weight: bold;
}

.imgContainerSelected,
.imgContainer {
    aspect-ratio: 1/1;
    padding: 10px;
}

.imgContainerSelected {
    border: 10px dotted whitesmoke;
    margin: 10px;
}

.gridImg {
    object-fit: contain;
    width: 100%;
    height: 100%;
}

.thumbDesc {
    text-align: center;
    color: #333;
}

#item-select {
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: white;
    font-size: 1rem;
    color: #333;
    min-width: 400px;

    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

/* Style on focus */
#item-select:focus {
    outline: none;
    border-color: #007bff;
    /* Example focus color */
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
    /* Example focus shadow */
}

/* Style disabled option */
#item-select option[disabled] {
    color: #999;
}
</style>
